import { FRAME_RATE } from "../core/constants.js";
import { getBruteforceMetricValue } from "./defaults.js";
import { EvaluationSession } from "./evaluation-session.js";

export class BruteforceEvaluator {
  async evaluate({ levelId, scriptText, scriptEvents = null, targetFrame, spikesKill = false, metric = "x" }) {
    const session = new EvaluationSession({
      levelId,
      scriptText,
      scriptEvents,
      spikesKill,
    });
    try {
      const result = session.runUntil(targetFrame);
      const metricValue = getBruteforceMetricValue(result.telemetry, metric);
      return {
        ...result,
        score: metricValue,
        metricValue,
        seconds: result.telemetry.frame / FRAME_RATE,
      };
    } finally {
      session.dispose();
    }
  }
}
